/*       */

import { gql } from '@apollo/client';

export default gql`
    query personAutocompleteDeprecatedQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: people(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            type
            name
            image
        }
    }
`;
